import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Iter 741 — GA4 helpers (G-Q0Q7V0BNZY). The loader lives in
 * public/index.html with send_page_view:false; the SPA reports
 * page_view on every route change via <AnalyticsPageViews/> and
 * features call gaEvent() for the GA4 recommended events
 * (view_item, generate_lead, post_ad, search, sign_up, login).
 * No-ops when GA didn't load (admin/till paths, blockers, SSR).
 */
export function gaEvent(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}

const SKIP = /^\/(admin|admin_panel|wp-admin|till)(\/|$)/;

export function AnalyticsPageViews() {
  const loc = useLocation();
  useEffect(() => {
    if (SKIP.test(loc.pathname)) return undefined;
    // Let Helmet settle the document title before reporting.
    const t = setTimeout(() => {
      gaEvent("page_view", {
        page_path: loc.pathname + loc.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }, 250);
    return () => clearTimeout(t);
  }, [loc.pathname, loc.search]);
  return null;
}
